import { getDetailedErrorMessage } from "../../../utils/validation";
export class AdvertiserPricingFetchFailed extends Error {
    /**
     * @param apiError - The error received from the API.
     * @param fallbackMessage - The message to use if the API error is not relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        this.apiError = apiError;
        this.fallbackMessage = fallbackMessage;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserPricingFetchFailed);
        }
        this.name = "AdvertiserPricingFetchFailed";
        this.message = `Failed to fetch advertiser pricing. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
export class AdvertiserPricingSaveFailed extends Error {
    /**
     * @param apiError - The error received from the API.
     * @param fallbackMessage - The message to use if the API error is not relevant.
     */
    constructor(apiError, fallbackMessage = "Please try again at a later time.") {
        super();
        this.apiError = apiError;
        this.fallbackMessage = fallbackMessage;
        if (Error.captureStackTrace) {
            Error.captureStackTrace(this, AdvertiserPricingSaveFailed);
        }
        this.name = "AdvertiserPricingSaveFailed";
        this.message = `Failed to save advertiser pricing. ${getDetailedErrorMessage(apiError, fallbackMessage)}`;
    }
}
//# sourceMappingURL=errors.js.map